import PropTypes from "prop-types";
import React from "react";
import Heading from "../../elements/heading";
import Image from "../../elements/image";
import PropTypePrimaryButton from "../../prop-types/primary-button";
import "./style.scss";

const HeroGradient = ({
  heading,
  headingType,
  subHeading,
  subHeadingType,
  image,
  backgroundImage
}) => {
  heading.className = "type-h1";
  let backgroundStyle = {};
  if (backgroundImage.value.src) {
    backgroundStyle = {
      backgroundImage: "url(" + backgroundImage.value.src + ")"
    };
  }

  return (
    <section className="hero-gradient grid" style={backgroundStyle}>
      <div className="hero-gradient-content">
        {heading && (
          <Heading
            type={headingType}
            html={heading}
            className="hero-heading"
            typographyClass="type-h1"
          />
        )}
        {subHeading && (
          <div className="hero-sub-heading">
            <Heading type={subHeadingType} html={subHeading} />
          </div>
        )}
        {image && (
          <div className="hero-support">
            <Image {...image} />
          </div>
        )}
      </div>
      {image && <div className="radial-gradient" />}
    </section>
  );
};

HeroGradient.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.shape({
    text: PropTypes.string,
    cta: PropTypePrimaryButton
  })
};

export default HeroGradient;
